import { Hardware } from 'voximplant-websdk';
import type { MediaRenderer } from 'voximplant-websdk/Media/MediaRenderer';

import type { IUser } from 'store/declare';

import { videoManager } from 'manager/videoManager';

/** Установить слушатель события создания локального видео */
export function attachVOXLocalMediaRendererAdded(userId: string, setCurrentUser: React.Dispatch<React.SetStateAction<IUser | null>>) {
    Hardware.StreamManager.get().on(Hardware.HardwareEvents.MediaRendererAdded, ({ renderer }: { renderer: MediaRenderer }) => {
        videoManager.set({ mediaRenderer: renderer, userId });

        setCurrentUser(prevState => (prevState ? { ...prevState, isCameraEnabled: true } : prevState));
    });
    Hardware.StreamManager.get().on(Hardware.HardwareEvents.MediaRendererRemoved, () => {
        videoManager.remove(userId);

        setCurrentUser(prevState => (prevState ? { ...prevState, isCameraEnabled: false } : prevState));
    });
}
